export default __webpack_public_path__ + "static/media/bush.a322f8dd.png";